import BaseLink from "@/components/common/base-link/base-link";
import { ReactNode } from "react";

interface IReference {
  reference: {
    _type: string;
    slug?: { current: string };
    product?: { slug: { current: string } };
  };
}

interface IInternalLinkProps {
  children: ReactNode;
  value: IReference;
}

const InternalLink = (props: IInternalLinkProps) => {
  const { children, value } = props;
  const text = (children as any[])[0] ?? "";

  if (!text) {
    return null;
  }

  if (!value?.reference || !value.reference._type) {
    return <>{children}</>;
  }

  const getHref = (value: IReference) => {
    let href = "/";

    switch (value.reference._type) {
      case "article":
        href = `/learn/${value.reference.slug?.current}`;
        break;
      case "productDetailPage":
        href = `/loan/${value.reference.product?.slug?.current}`;
        break;
      case "glossaryTerm":
        href = `/glossary/${value.reference.slug?.current}`;
        break;
    }

    return href;
  };

  const href = getHref(value);

  return (
    <BaseLink href={href} className="underline">
      {text}
    </BaseLink>
  );
};

export default InternalLink;
